import { useEffect, useRef, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import ProcessItemCard from "./ProcessItemCard";
import { useUserStore } from "../store/userStore";
import { toast } from "react-toastify";
import {
  desfavoritarProcessByEmail,
  favoritarProcessByEmail,
} from "../services/clientService";
import { useProcessStore } from "../store/useProcessStore";

interface CardViewProcessProps {
  list: any;
  loadMoreData: () => void;
  isLoading: boolean;
  reloadData: any;
  hasMore: boolean;
}

const CardViewProcesses: React.FC<CardViewProcessProps> = (
  props: CardViewProcessProps
) => {
  const [loading, setLoading] = useState(false);
  const [processList, setProcessList] = useState<any>([]);
  const currentUserEmail = useUserStore((state) => state.email);
  const token = useUserStore((state) => state.idToken);

  const containerRef = useRef<HTMLDivElement>(null);
  const { reloadFlag, toggleReload } = useProcessStore();

  useEffect(() => {
    setProcessList(props.list);
  }, [props.list]);

  const handleScroll = () => {
    if (containerRef.current && !props.isLoading) {
      const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
      if (scrollHeight - scrollTop <= clientHeight + 50) {
        props.loadMoreData();
      }
    }
  };

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      const { scrollHeight, clientHeight } = container;
      if (
        scrollHeight <= clientHeight &&
        props.list.length > 0 &&
        !props.isLoading
      ) {
        props.loadMoreData();
      }
    }
  }, [props.list, props.isLoading]);

  const handleAssociar = async (codigo: string, isCurrentlyFav: boolean) => {
    const email = currentUserEmail;

    try {
      if (!isCurrentlyFav) {
        await favoritarProcessByEmail(codigo, email, token);
        toast.success("Processo favoritado com sucesso!");
      } else {
        await desfavoritarProcessByEmail(codigo, email);
        toast.success("Processo desfavoritado com sucesso!");
      }

      toggleReload();
      props.reloadData();
    } catch (error: any) {
      console.error("Erro:", error.response?.data || error.message);
      toast.error("Erro ao atualizar associação.");
    }
  };

  return (
    <>
      {!props.isLoading && processList.length === 0 && (
        <Box textAlign="left" color="#666" fontSize="1rem">
          Nenhum processo encontrado.
        </Box>
      )}
      {processList.length > 0 && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: "86%",
          }}
        >
          <Box
            ref={containerRef}
            onScroll={handleScroll}
            sx={{
              flexGrow: 1,
              overflowY: "auto",
              height: "100%",
              maxHeight: "calc(100vh - 100px)",
              padding: {
                xs: 0,
                sm: 2,
                md: 2,
              },
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": { display: "none" },
            }}
          >
            {loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  padding: "10px",
                }}
              >
                <Box display="flex" justifyContent="center" alignItems="center">
                  <CircularProgress
                    size={48}
                    thickness={4}
                    style={{ color: "#326AFD" }}
                  />
                </Box>
              </div>
            ) : (
              <Box
                display="grid"
                gridTemplateColumns="repeat(auto-fill, minmax(250px, 1fr))"
                gap={2}
              >
                {processList.map((process: any) => {
                  const userEmails = Array.isArray(process?.clientes)
                    ? process.clientes
                    : [];
                  const isUserFav = userEmails.includes(currentUserEmail);

                  return (
                    <ProcessItemCard
                      key={process.CD_PROCESSO}
                      process={process}
                      onClick={() =>
                        handleAssociar(process.CD_PROCESSO, isUserFav)
                      }
                      checked={isUserFav}
                    />
                  );
                })}
              </Box>
            )}
            {props.isLoading && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  padding: "10px",
                }}
              >
                <Box display="flex" justifyContent="center" alignItems="center">
                  <CircularProgress
                    size={48}
                    thickness={4}
                    style={{ color: "#326AFD" }}
                  />
                </Box>
              </div>
            )}
          </Box>
        </Box>
      )}
    </>
  );
};

export default CardViewProcesses;
